import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import BaseModal from 'Modals/BaseModal';
import PropTypes from 'prop-types';
import RecipientBuilderFinishModalBody from './RecipientBuilderFinishModalBody';

const RecipientBuilderFinishModal = props => (
  <BaseModal
    modalType={ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_FINISH}
    activeModal={props.activeModal}
    closeModal={props.close}
    includeHeaderCloseButton
    isOpen={props.isOpen}
    bodyContent={
      <RecipientBuilderFinishModalBody
        close={props.close}
        finish={props.finish}
      />
    }
  />
);

RecipientBuilderFinishModal.defaultProps = {
  activeModal: '',
};

RecipientBuilderFinishModal.propTypes = {
  activeModal: PropTypes.oneOf([
    ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_INTRO,
    ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_FINISH,
    '',
  ]),
  close: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default RecipientBuilderFinishModal;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/RecipientBuilderFinishModal/index.jsx